import { Component, computed, HostBinding, input } from '@angular/core';
import { ThemeColor } from '../helpers';

@Component({
  selector: 'app-pan-stat-card',
  templateUrl: './pan-stat-card.component.html',
  styleUrl: './pan-stat-card.component.scss',
  standalone: false,
})
export class PanStatCardComponent {
  public value = input.required<string>();
  public stat = input.required<string>();
  public icon = input<string>();
  public color = input<ThemeColor>('default');
  public width = input<string>('w-full');

  public classes = computed(() => {
    return ['statcard', `statcard-color-${this.color()}`, this.width()];
  });

  @HostBinding('class')
  get hostClasses() {
    return ['block', this.width()];
  }
}
